/**
 * IMPULSE 9 MIGRATION: This file is theme-agnostic — carries over unchanged.
 * Toggles class 'has-coverage' on #CartDrawer based on checkbox state.
 * All Loop button show/hide is handled by CSS in c-returns-coverage.liquid.
 * Theme-specific adapter (subtotal, button label) lives in that snippet too.
 */
class ReturnsCoverageCheckbox extends HTMLElement {
  connectedCallback() {
    this._price  = parseFloat(this.getAttribute('coverage-price') || '3.98');
    this._drawer = document.getElementById('CartDrawer');
    this._render();
  }

  _render() {
    this.innerHTML = `
      <label class="rcc__row">
        <span class="rcc__left">
          <input type="checkbox" class="rcc__input" aria-label="Add returns coverage">
          <span class="rcc__box" aria-hidden="true"></span>
          <span class="rcc__label">
            Add returns coverage
            <span class="rcc__info" aria-hidden="true">
              <svg width="15" height="15" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 9.5v4.5M10 6.5h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
          </span>
        </span>
        <span class="rcc__price">+$${this._price.toFixed(2)}</span>
      </label>`;

    this.querySelector('.rcc__input').addEventListener('change', this._onToggle.bind(this));
  }

  _onToggle(e) {
    this._drawer?.classList.toggle('has-coverage', e.target.checked);
  }
}

customElements.define('returns-coverage-checkbox', ReturnsCoverageCheckbox);
